import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { useNavigate, useParams } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';

const ViewByDropdown = ({ children, module, viewByDefault }) => {
  const { viewBy } = useParams();
  const navigate = useNavigate();

  const handleOnChange = R.compose(
    navigate,
    R.concat(`../${module}/`),
    R.path(['target', 'value'])
  );

  return (
    <FormControl fullWidth>
      <InputLabel id="view-by-label">View By</InputLabel>
      <Select
        fullWidth
        label="View By"
        labelId="view-by-label"
        onChange={handleOnChange}
        value={viewBy ?? viewByDefault}
      >
        {children}
      </Select>
    </FormControl>
  );
};

ViewByDropdown.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
    .isRequired,
  module: PropTypes.string.isRequired,
  viewByDefault: PropTypes.string,
};

ViewByDropdown.defaultProps = {
  viewByDefault: 'location',
};

export default ViewByDropdown;
